<template>
    <div class="d-flex align-items-center justify-content-center cursor-pointer" @click="showModal = true">
        <slot></slot>
    </div>
    <VideoModal v-model="showModal" :video-id="videoId"/>
</template>

<script setup>
import { ref } from 'vue'
import VideoModal from './VideoModal';

const props = defineProps({
    videoId: {
        type: String
    },
})
const showModal = ref(false)
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}
</style>
